import CreditPurchase from './credit-purchase.vue'
export default CreditPurchase
